/** FAQ, Support, and Advertising page copy (Polish translation). */
export const pagesMessagesPl = {
  faq: {
    pageTitle: "Najczęściej zadawane pytania",
    pageSubtitle: "Znajdź odpowiedzi na najczęstsze pytania dotyczące WasOK",
    seoTitle: "FAQ — WasOK",
    seoDescription:
      "Odpowiedzi na najczęstsze pytania dotyczące WasOK, skanowania produktów, prywatności i ocen.",
    items: [
      {
        question: "Jak działa WasOK?",
        answer:
          "WasOK pomaga Ci pamiętać, które produkty Ci smakowały, a które nie, dzięki skanowaniu kodów kreskowych i zapisywaniu ocen oraz notatek. Po prostu zeskanuj kod kreskowy produktu, oceń go, dodaj notatki, a następnym razem, gdy zeskanujesz ten sam produkt, od razu zobaczysz swoją poprzednią recenzję.",
      },
      {
        question: "Czy moje dane są przechowywane w chmurze?",
        answer:
          "Nie! Wszystkie Twoje dane są przechowywane lokalnie na Twoim urządzeniu. Nie synchronizujemy Twoich informacji z chmurą, co oznacza, że Twoja historia zakupów i opinie o produktach pozostają całkowicie prywatne. Oznacza to jednak również, że powinieneś wykonywać kopie zapasowe urządzenia, jeśli chcesz zachować swoje dane.",
      },
      {
        question: "Czy potrzebuję połączenia z internetem, aby korzystać z WasOK?",
        answer:
          "Nie, WasOK działa całkowicie offline. Ponieważ wszystkie Twoje dane są przechowywane lokalnie na urządzeniu, możesz skanować produkty, dodawać oceny i przeglądać historię bez żadnego połączenia z internetem.",
      },
      {
        question: "Czy mogę używać WasOK dla dowolnego rodzaju produktu?",
        answer:
          "Tak! WasOK działa z każdym produktem, który ma kod kreskowy. Niezależnie od tego, czy to jedzenie, kosmetyki, artykuły gospodarstwa domowego, elektronika czy cokolwiek innego z kodem kreskowym, możesz to zeskanować i zapisać swoją opinię.",
      },
      {
        question: "Jak zeskanować kod kreskowy?",
        answer:
          "Po prostu otwórz aplikację WasOK i dotknij przycisku skanowania. Skieruj kamerę na kod kreskowy produktu, a aplikacja automatycznie go wykryje i zeskanuje. Upewnij się, że kod kreskowy jest dobrze oświetlony i wyraźny, aby uzyskać najlepsze rezultaty.",
      },
      {
        question: "Czy mogę dodawać zdjęcia do moich recenzji produktów?",
        answer:
          "Tak! Możesz dołączyć zdjęcia do dowolnej recenzji produktu. Jest to szczególnie pomocne, gdy chcesz zapamiętać szczegóły opakowania, listę składników lub inne informacje wizualne, które mogą Ci pomóc przypomnieć sobie, dlaczego produkt Ci się podobał lub nie.",
      },
      {
        question: "Jakie informacje mogę zapisywać o produktach?",
        answer:
          "Możesz zapisywać oceny (1-5 gwiazdek), notatki tekstowe, zdjęcia, zapłaconą cenę, miejsce zakupu oraz własne kategorie. Te kompleksowe informacje pomagają podejmować świadome decyzje podczas zakupów.",
      },
      {
        question: "Czy mogę tworzyć listy zakupów?",
        answer:
          "Tak! WasOK pozwala tworzyć listy zakupów z produktów, które już oceniłeś. Dzięki temu łatwo zapamiętać, które produkty Ci się podobały i które chcesz kupić ponownie.",
      },
      {
        question: "Jak mogę organizować moje produkty?",
        answer:
          "Możesz organizować produkty za pomocą własnych kategorii. Na przykład możesz utworzyć kategorie takie jak „Przekąski”, „Kawa”, „Pielęgnacja skóry” czy „Środki czystości”. Dzięki temu łatwo przeglądać recenzje według typu.",
      },
      {
        question: "Czy WasOK jest darmowy w użyciu?",
        answer:
          "Tak, WasOK jest całkowicie darmowy do pobrania i użytkowania. Nie ma żadnych zakupów w aplikacji, subskrypcji ani ukrytych opłat. Uważamy, że każdy powinien mieć dostęp do prywatnego sposobu zapamiętywania swoich preferencji dotyczących produktów.",
      },
      {
        question: "Czy WasOK jest dostępny dla osób z niepełnosprawnościami?",
        answer:
          "WasOK jest zaprojektowany tak, aby był użyteczny dla jak największej liczby osób. Aplikacja zawiera funkcje ułatwień dostępu, takie jak obsługa czytników ekranu, skalowalny tekst i opcjonalny tryb wysokiego kontrastu.",
      },
      {
        question: "Co się stanie, jeśli odinstaluję aplikację?",
        answer:
          "Ponieważ wszystkie dane są przechowywane lokalnie na Twoim urządzeniu, odinstalowanie aplikacji usunie wszystkie Twoje recenzje produktów, notatki i listy zakupów. Przed odinstalowaniem pamiętaj o wyeksportowaniu danych, jeśli chcesz zachować kopię zapasową.",
      },
      {
        question: "Czy mogę wyeksportować moje dane?",
        answer:
          "Tak, WasOK pozwala eksportować dane w celach kopii zapasowej. Możesz wyeksportować wszystkie swoje recenzje do pliku, który możesz zapisać na urządzeniu lub w wybranej przez siebie usłudze chmurowej.",
      },
      {
        question: "Czy WasOK śledzi moją lokalizację?",
        answer:
          "Nie, WasOK nie śledzi Twojej lokalizacji. Chociaż możesz ręcznie wpisać nazwę sklepu, w którym kupiłeś produkt, aplikacja nie korzysta z GPS ani usług lokalizacyjnych.",
      },
      {
        question: "Czy mogę korzystać z WasOK na wielu urządzeniach?",
        answer:
          "Obecnie WasOK nie synchronizuje się między urządzeniami, ponieważ wszystkie dane są przechowywane lokalnie. Każde urządzenie będzie miało własną, oddzielną bazę danych produktów i recenzji.",
      },
      {
        question: "Co zrobić, jeśli kod kreskowy się nie skanuje?",
        answer:
          "Jeśli kod kreskowy się nie skanuje, upewnij się, że jest dobrze oświetlony i wyraźny. Możesz również spróbować wyczyścić obiektyw aparatu. Jeśli kod kreskowy jest uszkodzony lub niewyraźny, możesz mieć możliwość ręcznego wpisania numeru kodu kreskowego.",
      },
    ],
    cta: {
      heading: "Nadal masz pytania?",
      body: "Skontaktuj się z naszym zespołem wsparcia — chętnie pomożemy.",
      button: "Skontaktuj się z pomocą",
    },
  },
  support: {
    pageTitle: "Wsparcie",
    seoTitle: "Wsparcie — WasOK",
    seoDescription:
      "Uzyskaj pomoc dotyczącą WasOK: skontaktuj się z pomocą techniczną, zgłoś błędy i podziel się opinią.",
    getHelp: {
      title: "Uzyskaj pomoc",
      body: "Jesteśmy tutaj, aby pomóc Ci jak najlepiej wykorzystać WasOK. Jeśli masz problemy lub pytania, mamy dla Ciebie kilka dostępnych zasobów.",
    },
    faq: {
      title: "Najczęściej zadawane pytania",
      body: "Zanim się z nami skontaktujesz, sprawdź naszą sekcję FAQ, gdzie odpowiadamy na najczęstsze pytania dotyczące WasOK. Znajdziesz tam szczegółowe informacje o tym, jak działa aplikacja, prywatności, przechowywaniu danych i innych kwestiach.",
    },
    contact: {
      title: "Kontakt z pomocą techniczną",
      body: "Jeśli nie możesz znaleźć odpowiedzi, której szukasz, nasz zespół wsparcia jest gotowy do pomocy. Możesz się z nami skontaktować pod adresem:",
      emailLabel: "E-mail:",
      responseTime: "Zazwyczaj odpowiadamy w ciągu 24-48 godzin",
    },
    bugs: {
      title: "Zgłaszanie błędów",
      body: "Znalazłeś błąd? Doceniamy Twoją pomoc w ulepszaniu WasOK. Zgłaszając błąd, dołącz proszę:",
      items: [
        "Szczegółowy opis problemu",
        "Kroki potrzebne do odtworzenia problemu",
        "Model urządzenia i wersję systemu Android",
        "Zrzuty ekranu lub nagrania ekranu, jeśli to możliwe",
      ],
      sendPrefix: "Wyślij zgłoszenia błędów na adres:",
    },
    featureRequests: {
      title: "Propozycje funkcji",
      bodyBefore:
        "Masz pomysł na nową funkcję? Chętnie go poznamy! Wyślij swoje sugestie na adres",
      bodyAfter:
        ". Chociaż nie możemy wdrożyć każdej prośby, dokładnie rozważamy wszystkie opinie podczas planowania przyszłych aktualizacji.",
    },
    knownIssues: {
      title: "Znane problemy",
      body: "Obecnie znamy następujące problemy i pracujemy nad ich rozwiązaniem:",
      items: [
        "Niektóre kody kreskowe mogą się nie skanować przy słabym oświetleniu — spróbuj użyć latarki",
        "Bardzo długie notatki o produktach mogą chwilę się zapisywać na starszych urządzeniach",
        "Miniatury zdjęć mogą wyglądać na piksowane na wyświetlaczach o wysokiej rozdzielczości",
      ],
    },
    appUpdates: {
      title: "Aktualizacje aplikacji",
      body: "Regularnie wydajemy aktualizacje z nowymi funkcjami, ulepszeniami i poprawkami błędów. Pamiętaj, aby aktualizować WasOK przez Google Play Store, aby otrzymywać najnowsze usprawnienia.",
    },
    community: {
      title: "Społeczność",
      body: "Dołącz do naszej społeczności użytkowników, którzy podejmują mądrzejsze decyzje zakupowe dzięki WasOK. Dziel się wskazówkami, zadawaj pytania i łącz się z innymi użytkownikami na naszych kanałach społecznościowych.",
    },
    emergency: {
      title: "Wsparcie w nagłych przypadkach",
      body: 'Jeśli napotkasz krytyczny problem, który uniemożliwia korzystanie z aplikacji, oznacz swój e-mail jako "PILNE" w temacie wiadomości, a my priorytetowo potraktujemy Twoje zgłoszenie.',
    },
    cta: {
      heading: "Nadal potrzebujesz pomocy?",
      body: "Nasz zespół wsparcia jest tu dla Ciebie. Nie wahaj się skontaktować z nami w razie jakichkolwiek pytań lub wątpliwości.",
      button: "Napisz do wsparcia",
    },
  },
  advertising: {
    pageTitle: "Reklamy i monetyzacja",
    seoTitle: "Reklamy — WasOK",
    seoDescription: "Jak WasOK podchodzi do reklam i monetyzacji.",
    approach: {
      title: "Nasze podejście",
      body: "W WasOK wierzymy, że Twoje nawyki zakupowe i opinie o produktach są prywatne i osobiste. Nasz model biznesowy odzwierciedla tę podstawową wartość.",
    },
    noAds: {
      title: "Brak reklam",
      body: "WasOK nie wyświetla żadnych reklam. Nigdy nie pokażemy Ci reklam na podstawie produktów, które skanujesz, ocen, które wystawiasz, ani żadnych innych danych, które tworzysz w aplikacji. Korzystanie z WasOK jest całkowicie wolne od reklam.",
    },
    noDataSelling: {
      title: "Brak sprzedaży danych",
      body: "Nie sprzedajemy, nie wynajmujemy ani nie udostępniamy Twoich danych reklamodawcom, brokerom danych ani żadnym stronom trzecim. Ponieważ wszystkie Twoje dane są przechowywane lokalnie na urządzeniu, nawet my nie mamy do nich dostępu. Twoje recenzje produktów, listy zakupów i notatki należą wyłącznie do Ciebie.",
    },
    noTracking: {
      title: "Brak śledzenia",
      body: "WasOK nie korzysta z pikseli śledzących, usług analitycznych ani żadnej innej technologii, która monitoruje Twoje zachowanie lub udostępnia informacje stronom trzecim. Nie śledzimy, jakie produkty skanujesz, w jakich sklepach robisz zakupy ani jak korzystasz z aplikacji.",
    },
    sustainability: {
      title: "Jak utrzymujemy się finansowo",
      body: "Możesz się zastanawiać, jak utrzymujemy WasOK za darmo bez reklam czy sprzedaży danych. Nasze podejście jest proste:",
      items: [
        {
          label: "Darmowy i otwarty:",
          text: "WasOK jest darmowy dla wszystkich, bez wersji premium czy płatnych barier",
        },
        {
          label: "Oszczędna działalność:",
          text: "Utrzymujemy niskie koszty, tworząc wydajne oprogramowanie skoncentrowane na prywatności",
        },
        {
          label: "Dobrowolne darowizny:",
          text: "Użytkownicy, którzy kochają WasOK, mogą nas wesprzeć poprzez dobrowolne darowizny",
        },
        {
          label: "Otwarte źródło:",
          text: "Możemy oferować usługi konsultingowe lub tworzenie rozwiązań na zamówienie dla organizacji",
        },
      ],
    },
    noAffiliate: {
      title: "Brak linków partnerskich",
      body: "WasOK nie korzysta z linków afiliacyjnych ani nie otrzymuje prowizji od sprzedawców. Kiedy skanujesz produkt, nie przekierowujemy Cię do jego zakupu w żadnym miejscu. Aplikacja służy wyłącznie do prowadzenia osobistych zapisów i podejmowania decyzji.",
    },
    noPromotions: {
      title: "Brak promocji produktów",
      body: "Nie przyjmujemy płatności od marek ani producentów za promowanie ich produktów. WasOK nigdy nie będzie sugerować produktów, wyróżniać konkretnych marek ani wpływać na Twoje oceny w jakikolwiek sposób. Twoje opinie należą tylko do Ciebie.",
    },
    partnerships: {
      title: "Partnerstwa z osobami trzecimi",
      body: "WasOK nie współpracuje z firmami marketingowymi, agregatorami danych ani sieciami reklamowymi. Działamy niezależnie i stawiamy Twoją prywatność ponad wszystko.",
    },
    future: {
      title: "Plany na przyszłość",
      body: "Zależy nam na tym, aby WasOK pozostał wolny od reklam i skoncentrowany na prywatności. Jeśli kiedykolwiek będziemy musieli wprowadzić zrównoważony model biznesowy w przyszłości, to:",
      items: [
        "Ogłosimy wszelkie zmiany z odpowiednim wyprzedzeniem",
        "Nigdy nie pójdziemy na kompromis w kwestii prywatności czy bezpieczeństwa danych",
        "Zawsze zaoferujemy sposób korzystania z aplikacji bez śledzenia czy reklam",
        "Wysłuchamy opinii i obaw użytkowników",
      ],
    },
    supporting: {
      title: "Wspieranie WasOK",
      body: "Jeśli kochasz WasOK i chcesz wesprzeć naszą misję zorientowanej na prywatność pamięci zakupowej, możesz:",
      items: [
        "Opowiedzieć o aplikacji znajomym i rodzinie",
        "Zostawić pozytywną recenzję w Google Play Store",
        "Podzielić się z nami swoją opinią i sugestiami",
        "Rozważyć dobrowolną darowiznę (gdy będzie dostępna)",
      ],
    },
    cta: {
      heading: "Masz pytania dotyczące naszych zasad?",
      body: "Jesteśmy transparentni w kwestii tego, jak działa WasOK. Jeśli masz jakiekolwiek pytania dotyczące naszego podejścia do prywatności, monetyzacji czy zrównoważonego rozwoju, skontaktuj się z nami.",
      button: "Skontaktuj się z nami",
    },
  },
};
